/* Couch Quest: one-shot scroll reveals.
   Adds .is-revealed to [data-cq-reveal] once, the first time it is properly on screen, then stops watching it.
   - data-cq-reveal="0.6" sets how much must be visible (0 to 1) before it plays. Empty means as soon as it appears.
   - If the element contains [data-cq-reveal-anchor], that child is what must be visible (e.g. the price at the
     bottom of a card), so the motion never plays while the moving part is still below the screen edge.
     Never put the anchor on an element that is itself clipped/hidden while waiting: it would never count as visible.
   Hidden "before" states live in cq-motion.css and only apply under html.cq-motion. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('cq-motion')) return; /* safety timer already gave up, or no IntersectionObserver */
  root.classList.add('cq-motion-ready');

  var observers = {};

  function getObserver(threshold) {
    if (observers[threshold]) return observers[threshold];
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < threshold * 0.95) return;
        var host = entry.target.__cqRevealHost || entry.target;
        host.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: [0, 0.25, 0.5, 0.6, 0.75, 0.9, 0.95, 1] });
    observers[threshold] = io;
    return io;
  }

  function observe(scope) {
    scope.querySelectorAll('[data-cq-reveal]:not(.is-revealed)').forEach(function (el) {
      var threshold = parseFloat(el.getAttribute('data-cq-reveal'));
      if (!(threshold >= 0 && threshold <= 1)) threshold = 0;
      var target = el.querySelector('[data-cq-reveal-anchor]') || el;
      target.__cqRevealHost = el;
      getObserver(threshold).observe(target);
    });
  }

  observe(document);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
  }
})();
